/**
* @file 运营中心-工单
* */
<template>
  <div id="vehicleShift">
    <custom-table has-organization="true" ref="customTable" :customOptions="customOptions" :columns="columns"  labelWidth="135">
      <template slot="customTable-top">
        <el-radio-group v-model="status" @change="statusChange" style="padding-bottom: 16px">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button :label="item.value" v-for="item in $const.SHIFTORDERSTATUS" :key="item.value">
            {{ item.label }}
          </el-radio-button>
        </el-radio-group>
      </template>
      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'schedulingNo'"><span class="link" @click="getInfo(row)">
            {{ row.schedulingNo }}</span></template>
        <template v-else-if="item.prop === 'serviceTime'">{{
          row.serviceTime | filterTime
        }}</template>
        <template v-else-if="item.prop === 'finishTime'">{{
          row.finishTime | filterTime
        }}</template>
        <template v-else-if="item.prop === 'status'">{{
          row.status | filterConst("SHIFTORDERSTATUS")
        }}</template>

        <template v-else-if="item.prop === 'startStationName'">
          <div style="display: flex; align-items: center">
            <div>{{ row.startStationName }} - {{ row.endStationName }}</div>
          </div>
        </template>
        <template v-else-if="item.prop === 'licenseNo'">
          <span 
            v-if="row.licenseNo"
            :style="getPlateStyle(row.licenseNo)"
          >{{ formatPlateNumber(row.licenseNo) }}</span>
          <span v-else>-</span>
          <span v-if="row.vehicleSeat" style="margin-left: 4px;">{{ row.vehicleSeat }}座</span>
        </template>
        <template v-else-if="item.prop === 'seatType'">{{ row.seatType | filterConst("SEATTYPE") }}
        </template>
        <template v-else-if="item.prop === 'realTotalFee'">
          <span class="util-money" v-if="row.realTotalFee || row.realTotalFee === 0">{{ "¥" + row.realTotalFee }}</span>
          <span v-if="!row.realTotalFee && row.realTotalFee !== 0">-</span>
        </template>
        <template v-else-if="item.prop === 'totalAmount'">
          <span class="util-money" v-if="row.totalAmount || row.totalAmount === 0">{{ "¥" + row.totalAmount }}</span>
          <span v-if="!row.totalAmount && row.totalAmount !== 0">-</span>
        </template>

        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>
    <workOrderDetail :visible="detailsVisible" :order="order" @close="detailsVisible = false" v-if="detailsVisible" />
  </div>
</template>

<script>
import workOrderDetail from "./workOrderDetail.vue";
export default {
  name: "vehicleShift",
  components: { workOrderDetail },
  data() {
    return {
      // 班次状态
      status: "",
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/airport/orderDriver",
        // 请求的参数列表
        params: {
          status: this.status,
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          { type: "input", field: "schedulingNo", name: "工单号", value: "" },
          { type: "input", field: "licenseNo", name: "车辆号牌", value: "" },
          { type: "input", field: "driverName", name: "司机姓名", value: "" },
          { type: "input", field: "driverPhone", name: "司机电话", value: "" },
        ],
      },
      // 表头
      columns: [
        { prop: "schedulingNo", label: "行程编号", minWidth: 120 },
        { prop: "status", label: "行程状态", minWidth: 80 },
        { prop: "serviceTime", label: "出发时间", minWidth: 120 },
        { prop: "finishTime", label: "完成/取消时间", minWidth: 120 },
        { prop: "startStationName", label: "线路名称", minWidth: 180 },
        { prop: "licenseNo", label: "车辆号牌", minWidth: 120 },
        { prop: "driverName", label: "司机姓名", minWidth: 80 },
        { prop: "driverPhone", label: "司机电话", minWidth: 120 },
        { prop: "passengerAllNum", label: "乘车人数", minWidth: 120 },
        { prop: "seatType", label: "类型", minWidth: 80 },
        { prop: "totalAmount", label: "总计金额", minWidth: 100 },
        { prop: "realTotalFee", label: "司机收入", minWidth: 100 },
      ],
      order: {},
      detailsVisible: false,
    };
  },
  methods: {
    /**
     * 状态改变
     */
    statusChange() {
      this.customOptions.params.page = 1;
      this.customOptions.params.status = this.status;
      this.$refs.customTable.listFn();
    },
    /**
     * 获取班次详情
     */
    async getInfo(row) {
      let url = "/api/v1/manage/airport/orderDriver/" + row.id;
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        this.order = {
          ...data.data,
          organizationName: row.organizationName
        }
        this.detailsVisible = true;
      }
    },
  },
  created() { },
};
</script>

